/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

class shareButton extends HTMLElement {
  constructor() {
    super();
   const copyLink = document.getElementById("copy_link");
   copyLink.addEventListener("click", function(event) {
    event.preventDefault();
    const urlToCopy = copyLink.getAttribute("data-URL");
    const decodedURL = decodeURIComponent(urlToCopy);
    const textArea = document.createElement("textarea");
    textArea.value = decodedURL;
    document.body.appendChild(textArea);
    textArea.select();
   document.execCommand('copy');
    document.body.removeChild(textArea);
       
    alert("已複製連結");
});
}
}
customElements.define("share-button", shareButton);

class akoProductForm extends HTMLElement {
  constructor() {
    super();
const defaultAddButton = document.querySelector(".product-form__add-button");
const AkoAddButton = document.querySelector(".ako_product-form__add-button");
const miniCart = document.getElementById("mini-cart");
defaultAddButton.addEventListener('click', function(e) {
 document.addEventListener('product:added', function(event) {
     miniCart.setAttribute('aria-hidden', 'false');
 });
});
AkoAddButton.addEventListener('click', function(e) {
  document.addEventListener('product:added', function(event) {
         miniCart.setAttribute('aria-hidden', 'true');
         window.location.href = "/cart";
  });
});

document.addEventListener('click', function(e) {
 if (!miniCart.contains(e.target)) {
     miniCart.setAttribute('aria-hidden', 'true');
 }
});
}
}
customElements.define("ako-product-form", akoProductForm);


class akoTwoSlideshow extends HTMLElement {
constructor() {
super();
let akoBlockSections = document.querySelectorAll('[data-slider-id]');
console.log(akoBlockSections);
akoBlockSections.forEach((block) => {
 const akoBlockSectionID = block.getAttribute('data-slider-id');
 const slider = block.querySelector('.ako-slick-' + akoBlockSectionID);
 const prevArrow = block.querySelector('.ako-left-' + akoBlockSectionID);
 const nextArrow = block.querySelector('.ako-right-' + akoBlockSectionID);
 $(slider).slick({
   dots: false,
   infinite: true,
   speed: 300,
   slidesToShow: 3,
   slidesToScroll: 1,
   adaptiveHeight: false,
   arrows: true,
   prevArrow: $(prevArrow),
   nextArrow: $(nextArrow),
   responsive: [{
     breakpoint: 999,
     settings: {
       arrows: true,
       centerMode: true,
       slidesToShow: 2,
     },
   },{
     breakpoint: 600,
     settings: {
       arrows: true,
       centerMode: true,
       slidesToShow: 1,
     },
   }],
 });
});

}
}

window.customElements.define("ako-two-slideshow", akoTwoSlideshow);

class keywordsSection extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("DOMContentLoaded", function () {
      const keywordsList = document.querySelector(".keywords-item");

      const isPinnedItems = keywordsData.filter((item) => item.isPin);
      const isPinnedAmount = isPinnedItems.length;

      const notPinnedAmount = 20 - isPinnedAmount;

      const notPinnedItems = keywordsData.filter(
        (item) => !isPinnedItems.includes(item)
      );
      const selectednotPinnedItems = [];
      while (
        selectednotPinnedItems.length < notPinnedAmount &&
        notPinnedItems.length > 0
      ) {
        const randomIndex = Math.floor(Math.random() * notPinnedItems.length);
        selectednotPinnedItems.push(notPinnedItems.splice(randomIndex, 1)[0]);
      }

      const finalRandomSelection = [
        ...isPinnedItems,
        ...selectednotPinnedItems,
      ];

      finalRandomSelection.forEach((item) => {
        const liElement = document.createElement("li");
        const aElement = document.createElement("a");
        aElement.href = item.URL;
        aElement.textContent = item.keywords;
        liElement.appendChild(aElement);
        keywordsList.appendChild(liElement);
      });
    });
  }
}
customElements.define("keywords-section", keywordsSection);

class keywordsMenu extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("DOMContentLoaded", function () {
      const keywordsList = document.querySelector(".keywords-item-menu");
      const isPinnedItems = keywordsDataMenu.filter((item) => item.isPin);
      const isPinnedAmount = isPinnedItems.length;

      const notPinnedAmount = 10 - isPinnedAmount;

      const notPinnedItems = keywordsDataMenu.filter(
        (item) => !isPinnedItems.includes(item)
      );
      const selectednotPinnedItems = [];
      while (
        selectednotPinnedItems.length < notPinnedAmount &&
        notPinnedItems.length > 0
      ) {
        const randomIndex = Math.floor(Math.random() * notPinnedItems.length);
        selectednotPinnedItems.push(notPinnedItems.splice(randomIndex, 1)[0]);
      }

      const finalRandomSelection = [
        ...isPinnedItems,
        ...selectednotPinnedItems,
      ];

      finalRandomSelection.forEach((item) => {
        const liElement = document.createElement("li");
        const aElement = document.createElement("a");
        aElement.href = item.URL;
        aElement.textContent = item.keywords;
        liElement.appendChild(aElement);
        keywordsList.appendChild(liElement);
      });
    });
  }
}
customElements.define("keywords-menu", keywordsMenu);

